import React from 'react';

import {Icon, IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {RuleEditorActionsGroupsEnum} from '../ruleActionModel';

/*
 * Types.
 */

interface RuleActionGroupIconProps {
  id: RuleEditorActionsGroupsEnum;
}

/*
 * Component.
 */

export const RuleActionGroupIcon = ({id}: RuleActionGroupIconProps) => {
  const theme = useUserTheme();
  return <Icon name={getIconName(id)} color={theme.greys.shade80} />;
};

/*
 * Helpers.
 */

function getIconName(id: string): IconName {
  switch (id) {
    case RuleEditorActionsGroupsEnum.TEAMMATES:
      return 'teammatesFilled';

    case RuleEditorActionsGroupsEnum.STATUS:
      return 'archiveFilled';

    case RuleEditorActionsGroupsEnum.ORGANIZATION:
      return 'tagFilled';

    case RuleEditorActionsGroupsEnum.MESSAGE:
      return 'sendFilled';

    case RuleEditorActionsGroupsEnum.COMMENT:
      return 'chatFilled';

    case RuleEditorActionsGroupsEnum.CONTACTS:
      return 'contactsFilled';

    case RuleEditorActionsGroupsEnum.THIRD_PARTY:
      return 'blocks';

    case RuleEditorActionsGroupsEnum.ACCOUNT:
      return 'briefcaseFilled';

    default:
      return 'inboxFilled';
  }
}
